import { yupResolver } from "@hookform/resolvers/yup";
import { IconArrowLeft } from "@tabler/icons-react";
import AppContext from "Context/appContext";
import { DISPLAYING_PAGES, PAGES, PROGRESS_STATE } from "constants";
import Bookinglist from "containers/BookingList";
import Cart from "containers/Cart";
import Completion from "containers/Completion";
import ContactDeatils from "containers/ContactDetails";
import ProductList from "containers/ProductList";
import { useEffect, useMemo, useState, useRef } from "react";
import { ProgressBar } from "react-bootstrap";
import { isValidPhoneNumber } from "react-phone-number-input";
import { ClipLoader } from "react-spinners";
import Button from "components/Button";
import { combineDateWithTime, isFieldFilled } from "utils";
import { useFormState } from "react-hook-form";
import { useForm } from "react-hook-form";
import UrlServices from "./services/Url";
import * as yup from "yup";
import axios from "axios";

// field validations schema
const schema = yup
  .object({
    firstName: yup.string(),
    lastName: yup.string(),
    model: yup.string(),
    email: yup.string().email("Invalid Email").required("Email is Required"),
    phone: yup
      .string()
      .required("Phone Number is Required")
      .test("phone", "Invalid Phone Number", (value) => {
        if (value) {
          return isValidPhoneNumber(value);
        }
        return true;
      }),
  })
  .test("name-required", "At least one of First Name or Last Name is required", function(value) {
    const { firstName, lastName } = value;
    if (!firstName && !lastName) {
      return this.createError({
        message: "At least one of First Name or Last Name is required"
      });
    }
    return true;
  })
  .required();


const AppManager = () => {
  const {
    register,
    handleSubmit,
    watch,
    control,
    reset,
    formState: { errors: formErrors },
    setValue,
    trigger,
  } = useForm({
    resolver: yupResolver(schema),
  });

  // States
  const [productCartDetail, setProductCartDetail] = useState(null);
  const [currentState, setCurrentState] = useState("PRODUCT");
  const [allProducts, setAllProducts] = useState([]);
  const [progressState, setProgressState] = useState(0);
  const [products, setProducts] = useState([]);
  const [formdata, setFormData] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    notes: "",
    option: "",
    model: "",
  });
  const [notificationWay, setNotificationWay] = useState("");
  const [appointmentDetail, setAppointmentDetail] = useState({
    date: "",
    start: "",
    end: "",
  });
  const [loading, setLoading] = useState(true);
  const [fetchTimeLoading, setFetchTimeLoading] = useState(true);
  const [prevState, setPrevState] = useState([]);
  const [prevStateCategory, setPrevStateCategory] = useState([]);
  const [progressStateCategory, setProgressStateCategory] = useState(0);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [currentModelsServices, setCurrentModelsServices] = useState([]);
  const [isMissedItem, setIsMissedItem] = useState(null);
  const [isBillable, setIsBillable] = useState(false);
  const [selectedStoreDetails, setSelectedStoreDetails] = useState(null);
  const [allServices, setAllServices] = useState([]);
  const [userSettings, setUserSettings] = useState({});
  const [productCartData, setProductCartData] = useState(null);
  const [allServicesForSubId, setAllServicesForSubId] = useState([]);
  const [encryptionKey, setEncryptionKey] = useState(null);
  const [countryDetails, setCountryDetails] = useState(null);
  const [errors, setErrors] = useState({
    // firstName: "",
    // lastName: "",
    phone: "",
    email: "",
  });
  const [reactHookFormData, setReactHookFormData] = useState({
    control: control,
    register: register,
    handleSubmit: handleSubmit,
    watch: watch,
    formErrors: formErrors,
    reset: reset,
    setValue: setValue,
    trigger: trigger,
  });
  const [buttonClicked, setButtonClicked] = useState(null);
  const [height, setHeight] = useState(window.innerHeight);
  const [widthProductSection, setWidthProductSection] = useState(0);
  const [defaultStore, setDefaultStore] = useState(null);
  const [toggle, setToggle] = useState(false);
  const [selectedBookingPage, setSelectedBookingPage] = useState({});
  const [buttonLoader, setButtonLoader] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isMobView, setIsMobView] = useState(false);
  const [isWebView, setIsWebView] = useState(false);
  const [othersWorkflow, setOthersWorkflow] = useState(false);
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [bookingList, setBookingList] = useState([]);
  const [filteredBookingList, setFilteredBookingList] = useState([]);

  const productSectionRef = useRef(null);

  const { notes, ...formDataObj } = formdata;
  const { model, ...modifiedData } = formdata;
  const { errors: formErrorss } = useFormState({
    control: reactHookFormData.control,
  });
  const { model: modelError, ...restErors } = formErrorss;

  //****// Function to check either form fields are valid or not
  const isFormValid = (obj) => {  
    const isModelRequired = productCartDetail?.skipForOthers;
    
    // Check if at least one name field is filled
    const isNameValid = isFieldFilled(obj.firstName) || isFieldFilled(obj.lastName);
    // Check if required fields are filled
    const phoneValid = isFieldFilled(obj.phone);
    const emailValid = isFieldFilled(obj.email);
    const optionValid = isFieldFilled(obj.option);
    const modelValid = !isModelRequired || isFieldFilled(obj.model);
    const fieldsFilled = phoneValid && emailValid && optionValid && isNameValid && modelValid;
    // Check if there are any validation errors
    const hasValidationErrors = Object.keys(formErrorss).length > 0;
    const finalResult = fieldsFilled && !hasValidationErrors;

    return finalResult;
  };

  // Function to check if appointment details are valid
  const isAppointmentValid = (appointmentData) => {
    if (!appointmentData) return false;
    return isFieldFilled(appointmentData.date) && 
           isFieldFilled(appointmentData.start) && 
           isFieldFilled(appointmentData.end);
  };

  // Function to detect if the user is on mobile view
  const detectMobView = () => {
    const screenWidth = window.innerWidth;
    setIsMobView(screenWidth <= 768); // Adjust breakpoint as needed
  };

  // Function to detect if the user is on web view
  const detectWebView = () => {
    const screenWidth = window.innerWidth;
    setIsWebView(screenWidth >= 768); // Adjust breakpoint as needed
  };

  const setServiceArray = () => {
    setPrevState({ ...prevState, [progressState]: products });
  };

  const updateDimensions = () => {
    setHeight(window.innerHeight);
  };

  const now = useMemo(
    () => {
      const totalSteps = bookingList.length === 1 ? 6 : 7;
      return ((progressState + 1) / totalSteps) * 100;
    },
    [progressState, bookingList.length]
  );

  // Function to reset the fields of contact detail page
  const resetContactDetailFields = () => {
    sessionStorage.removeItem("menuOption");
    setFormData({
      firstName: "",
      lastName: "",
      phone: "",
      email: "",
      notes: "",
      option: "",
      model: "",
    });
    reactHookFormData.reset();
    setNotificationWay("");
  }

  const api_base_url = process.env.REACT_APP_APPOINTMENT_PRO_API_URL;

  // Function to get data from RD Database
  const getDataFromRD = async () => {
    setProgressState(3);
    setIsBillable(true)  
    setLoading(true);
    try {
      const { data, status } = await axios.post(
        `${api_base_url}/${UrlServices.rdDeviceDetail}`,
        {
          bzy_d: selectedCategory.billable ? "" : selectedCategory.rd_device_id,
          bzy_b: selectedCategory.billable ? true : "",
          bzy_c: selectedCategory?.rd_category_id,
          q_: encryptionKey,
        }
      );
      if (status === 200) {
        setProductCartDetail({ ...productCartDetail, services: [], totalPrice: 0 });
        const item = data.data[0];
        const price = item?.sale_price?.startsWith("0")
          ? item?.retail_price
          : item?.sale_price;

        setProducts(data?.data);
        setProductCartData({
          device_name: selectedCategory.name,
          rd_device_id: selectedCategory.billable ? "" : selectedCategory.rd_device_id,
          price: price,
        });
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  // Function which saves the state while going Next
  const nextState = async () => {
    setProgressState(progressState + 1);
    setPrevState({ ...prevState, [progressState]: products });
    if(selectedCategory.billable) {
      getDataFromRD();
    } else {
      setProducts(selectedCategory.brands);
    }
  }

  // Function which saves the state while going Back
  const saveState = async () => {
    if (productCartDetail?.skipForOthers && progressState === 3 && !othersWorkflow) {
      // direct click of 'Others' Card
      // contact details page fields are reset while full back to the category page
      resetContactDetailFields();
      setProgressState(0);
      setCurrentState(DISPLAYING_PAGES.PRODUCT);
      setProducts(allProducts);
      setProductCartDetail(null);
      setPrevState([]);
      setPrevStateCategory([]);
      setProgressStateCategory(0);
      setSelectedCategory(null);
      return;
    } else if (productCartDetail?.skipForOthers && progressState === 3 && othersWorkflow) {
      // if 'No Services Available Found against a MODEL' go with 'Others' workflow scenario
      // check this scenario in the 'Card.js' Component for understanding

      // contact details page fields are reset while full back to the category page
      setOthersWorkflow(false);
      resetContactDetailFields();
      setProgressState(2);
      setCurrentState(DISPLAYING_PAGES.PRODUCT);
      setProducts(prevState[2]);
      setProductCartDetail(prevState => {
        // Destructure model, services, and skipForOthers, and keep the rest of the keys (category, brand, etc.)
        const { model, services, skipForOthers, ...updatedState } = prevState;
        return updatedState;  // Return the updated state without model, services, and skipForOthers
      });
      return;
    } else if (progressStateCategory > 0 && progressState === 0) {
      // this condition is for "simply running this condition is for "category and (subcategory children) back button handling"
      setProducts(prevStateCategory[progressStateCategory - 1]);
      setProgressStateCategory(progressStateCategory - 1);
      // Remove only the current state from prevState, not all states
      const updatedPrevState = { ...prevState };
      delete updatedPrevState[progressState];
      setPrevState(updatedPrevState);
      // Remove only the current state from prevStateCategory, not all states
      const updatedPrevStateCategory = { ...prevStateCategory };
      delete updatedPrevStateCategory[progressStateCategory];
      setPrevStateCategory(updatedPrevStateCategory);
      setIsBillable(false);
      return;
    } else if ((progressState !== 4 && progressState !== 5 && progressState !== 6) && progressStateCategory > 0 && Object.keys(selectedCategory).length > 0) {
      // this condition is for "if the "Next" button is clicked, then the back button will be handled here"
      if (prevState?.[0]?.length && !prevState?.[0]?.[0]?.billable) {
        setProducts(prevState[progressState - 1]);
        setProgressState(progressState - 1);
        // Remove only the current state from prevState, not all states
        const updatedPrevState = { ...prevState };
        delete updatedPrevState[progressState];
        setPrevState(updatedPrevState);
      } else if (prevState?.[0]?.length && prevState?.[0]?.[0]?.billable && progressState === 3) {
        // setProducts(selectedCategory.children);
        setProducts(prevState[prevState?.[0].length > 1 ? progressStateCategory - 1 : 0]);
        setProgressState(0);
        // Remove only the current state from prevState, not all states
        const updatedPrevState = { ...prevState };
        delete updatedPrevState[progressState];
        setPrevState(updatedPrevState);
      } else {
        // prevStateCategory has two objects in it "0 and 1" indexes, and we are setProducts to its 2nd index object which is not exist
        // so push the 2nd index object to the 1st index object
        if (prevStateCategory[progressStateCategory]?.length - 1 !== progressStateCategory) {
          setProducts(prevStateCategory[progressStateCategory - 1]);
        } else {
          setProducts(prevStateCategory[0]);
        }
        setProgressState(progressState - 1);
        if(progressStateCategory !== progressState) setProgressStateCategory(progressStateCategory - 1);
      }
      setIsBillable(false);
      return;
    } else if (isBillable && progressState === 3) {
      resetContactDetailFields();
      setProgressState(0);
      setProducts(allProducts);
      setProductCartDetail(null);
      setProductCartData(null);
      setIsBillable(false);
      return;
    } else if (progressState === 0) {
      setSelectedCategory(null);
      setIsBillable(false);
      return;
    } else if (progressState === 4) {
      setCurrentState(DISPLAYING_PAGES.PRODUCT);
    } else if (progressState === 5) {
      setButtonClicked(null);
      if (bookingList.length > 1) {
        setSelectedStoreDetails(null);
        setDefaultStore(null)
      }
      setCurrentState(DISPLAYING_PAGES.FORM);
      setProgressState(progressState - 1);
      return;
    } else if (progressState === 6) {
      setSelectedBookingPage({});
      setToggle(false);
      setDefaultStore(null);
      setProgressState(progressState - 1);
      setAppointmentDetail({
        date: "",
        start: "",
        end: "",
      });
      return;
    } else if (progressState === 7) {
      setCurrentState(DISPLAYING_PAGES.BOOKING);
      setProgressState(progressState - 1);
      return;
    } else if (progressState === 3) {
      // contact details page fields are reset while back to the models page
      resetContactDetailFields();
      setProductCartData(null);
      setProductCartDetail(prevState => {
        // Destructure services and totalPrice, and keep the rest (category, brand)
        const { services, totalPrice, ...updatedState } = prevState;
        return updatedState;  // Return the updated state without services and totalPrice
      });
      isMissedItem
        ? setCurrentModelsServices(products)
        : setCurrentModelsServices(prevState[progressState - 2][0].services);
    } else if (progressState === 2) {
      setProductCartDetail(prevState => {
        const { brand, ...updatedState } = prevState;
        return updatedState;  // Return the updated state without 'brand'
      });
    } else if (progressState === 2 && isMissedItem) {
      setProgressState(progressState - 2);
      setProducts(prevState[progressState - 2]);
      setIsMissedItem(null);
      setProductCartDetail(null);
      return;
    } else if (progressState === 1) {
      setProductCartDetail(null);
    }
    setProgressState(progressState - 1);
    const getData = prevState[progressState - 1];
    setProducts(getData);

    // Function to update width of product section
    const updateWidthProductSection = () => {
      const productSection = document.getElementById("product-section");
      if (productSection) {
        setWidthProductSection(productSection.offsetWidth);
      }
    };
    setTimeout(() => {
      updateWidthProductSection();
    }, 1);
  };

  // Function which finalize and submit the request of appointments and quotes
  const submitForm = async (clickedKey) => {
    if (clickedKey === "appointments") {
      setButtonClicked("appointment");
    } else if (clickedKey === "quote" && progressState === 4) {
      // Mark button as clicked
      setIsButtonClicked(true);

      // Validate form
      if (!isFormValid(formdata)) {
        // Now trigger validation (this will show errors, but not stop checkbox update)
        setProgressState(4);
        setCurrentState('FORM');

        return;
      }
      // and if the Form is Valid, proceed
      setButtonClicked("quote");
      setProgressState(6);
    }
    if (userSettings.isQuoteLocationsEnabled) {
      setCurrentState(DISPLAYING_PAGES.BOOKING);
    }
    try {
      setLoading(true);
      // setButtonLoader(true);
      const services = productCartDetail?.services.map((item) => {
        const price =
          item.sale_price &&
          typeof item.sale_price === "string" &&
          item.sale_price.startsWith("0")
            ? item.retail_price
            : item.sale_price;
        return {
          rd_issue_id: item.id,
          name: item.name,
          price: item?.price ? item?.price : price,
        };
      });

      const formattedTime = combineDateWithTime(
        appointmentDetail?.date,
        appointmentDetail?.start
      );
      const data = {
        device: productCartDetail?.category?.name || "",
        brand: isBillable ? "" : productCartDetail?.brand?.name || "others",
        model: isBillable ? "" :
          productCartDetail?.model?.name ||
          productCartData?.device_name ||
          formdata?.model,
        category_id: productCartDetail?.skipForOthers ? "" : userSettings?.isRDSync ? productCartDetail?.category.rd_category_id : productCartDetail?.brand.category,
        manufacturer_id: productCartDetail?.skipForOthers ? "" : (userSettings?.isRDSync && !isBillable) ? productCartDetail?.brand.rd_manufacturer_id : isBillable ? "" : productCartDetail?.brand._id,
        rd_device_id: isBillable ? "" : productCartData?.rd_device_id,
        date: formattedTime || "",
        start_time:
          appointmentDetail?.start !== "" ? appointmentDetail?.start : "",
        end_time: appointmentDetail?.end !== "" ? appointmentDetail?.end : "",
        issues: services,
        store_id: userSettings?.isQuoteLocationsEnabled
          ? selectedStoreDetails.store_id
          : "",
        store_name: userSettings?.isQuoteLocationsEnabled
          ? selectedStoreDetails.store_name
          : "",
        first_name: formdata.firstName ? formdata.firstName : "",
        last_name: formdata.lastName ? formdata.lastName : "",
        customer_email: formdata.email,
        customer_telephone: formdata.phone,
        customer_notes: formdata.notes,
        delivery_option: formdata?.option,
        delivery_status: formdata.status,
        total_price: productCartDetail?.totalPrice || 0,
        q_: encryptionKey,
        config_type: (isBillable && clickedKey === "quote") ? "billable_quote" : (isBillable && clickedKey === "appointments") ? "billable_appointments" : clickedKey,
      };
      // console.log(data);
      const API_BASE_URL = process.env.REACT_APP_APPOINTMENT_PRO_API_URL;
      const res = await fetch(
        `${API_BASE_URL}/${UrlServices.submitRequest}`,
        {
          method: "POST",
          body: JSON.stringify(data),
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        }
      );
      setLoading(false);
      // setButtonLoader(false);
      setCurrentState(DISPLAYING_PAGES.COMPLETION);
      const response = await res.json();
    } catch (error) {
      setLoading(false);
      // setButtonLoader(false);
      setProductCartData(null);
      console.log(error);
    }
  };

  const defaultFrameId =
    "My9TWjljRjY1V3F6c2xkZkxTRkkrazVYazNka1hITXBwSHVENXhSUjJ2YUtrWE5wb2s4SzNVZnpRWVg5SnZUUUJoRFN3QS9vZTJmeERWTXNjR3BZbHd5U3JTU3EwVVpyR0d3Mjg1L3hpY0U9";
  
  // Hook
  useEffect(() => {
    sessionStorage.removeItem("menuOption");
  }, []);
  
  // Hook
  useEffect(() => {
    if (productSectionRef.current && products?.length) {
      // Scroll to the top when products change or progressState changes
      productSectionRef.current.scrollTop = 0;
    }
  }, [products, progressState]);

  // Hook
  useEffect(() => {
    detectMobView();
    detectWebView();

    const targetObject = productCartDetail?.skipForOthers
      ? formErrorss
      : restErors;
    const propertiesLength =
      targetObject && typeof targetObject === "object"
        ? Object.keys(targetObject).length
        : 0;

    setIsDisabled(propertiesLength);

    var url = new URL(window.location.href);
    var params = new URLSearchParams(url.search);
    var frameId = params.get("frameId");

    const encrypted = decodeURIComponent(frameId ? frameId : defaultFrameId);
    setEncryptionKey(encrypted);

    window.addEventListener("resize", updateDimensions);
    window.addEventListener("resize", detectMobView);
    window.addEventListener("resize", detectWebView);
    return () => {
      window.removeEventListener("resize", updateDimensions);
      window.removeEventListener("resize", detectMobView);
      window.removeEventListener("resize", detectWebView);
    };
  }, [
    encryptionKey,
    height,
    productCartDetail,
    formErrorss,
    restErors,
    isWebView,
  ]);

  // Hook to update reactHookFormData when formErrors changes
  useEffect(() => {
    setReactHookFormData(prev => ({
      ...prev,
      formErrors: formErrors
    }));
  }, [formErrors]);

  return (
    <>
      <div
        style={isMobView ? {
          position: 'fixed',
          top: 0,
          left: '50%',
          transform: 'translateX(-50%)',
          width: '100%',
          maxWidth: '767px',
          minWidth: '350px',
          zIndex: 1000,
          backgroundColor: 'white'
        } : {}}
        className={`
        ${isMobView && !loading ? "rd-quote-justify-between" : ""}
        ${isMobView && loading ? "rd-quote-justify-end" : ""}
        rd-quote-pt-2 quote-row md:rd-quote-pl-[50px] xs:rd-quote-pl-[25px] rd-quote-items-center md:rd-quote-pr-[50px] xs:rd-quote-pr-[25px]`}
      >
        {/* Back Button */}
        {!loading && (
          <span className="rd-quote-w-[10%]" onClick={() => saveState()}>
            {((PROGRESS_STATE.includes(progressState) &&
              currentState !== DISPLAYING_PAGES.COMPLETION) ||
              (PROGRESS_STATE.includes(progressStateCategory) &&
                currentState !== DISPLAYING_PAGES.COMPLETION)) && (
                <span className="quote-header-img rd-quote-cursor-pointer">
                  <IconArrowLeft />
                </span>
              )}
          </span>
        )}

        {/* for MOBILE SCREEN only */}
        {/* (Continue), (Get Quote), (Book an Appointment) (Confirm Appointment) buttons */}
        <AppContext.Provider
          value={{
            setCurrentState,
            setProgressState,
            formdata,
            defaultStore,
            buttonClicked,
            setButtonClicked,
            progressState,
            appointmentDetail,
            isWebView,
            setOthersWorkflow,
            isButtonClicked,
            setIsButtonClicked,
            userSettings,
            isBillable,
            setIsBillable,
            bookingList,
            setBookingList,
            filteredBookingList,
            setFilteredBookingList,
            prevStateCategory,
            setPrevStateCategory,
            progressStateCategory,
            setProgressStateCategory,
            selectedCategory,
            setSelectedCategory,
          }}
        >
          {isMobView &&
            progressState === 3 && (
              <Button
                text={"Continue"}
                continueButtonWidth={true}
                buttonHeight={true}
                setServiceArray={setServiceArray}
                disabled={!productCartDetail?.services?.length > 0}
              />
            )}
          {isMobView && progressState === 4 && (
            <div className="rd-quote-flex rd-quote-gap-x-2 rd-quote-ml-3">
              {userSettings?.isAppointmentEnabled && (
                <Button
                  text="Book an Appointment"
                  appointmentButtonWidth={true}
                  buttonHeight={true}
                  typeA={true}
                  submit={() => {
                    // Mark button as clicked
                    setIsButtonClicked(true);

                    // Validate form
                    if (!isFormValid(formdata)) {
                      setProgressState(4);
                      setCurrentState('FORM');
                      reactHookFormData.trigger();
                      return;
                    } else {
                      setButtonClicked("appointment");
                    }
                  }}
                />
              )}
              
              {userSettings?.isQuoteEnabled && (
                <button
                  style={{
                    '--button-bg-color': userSettings?.colourHex?.buttonAndBorderColor || '#ebebeb'
                  }}
                  className={`rd-quote-bg-[var(--button-bg-color)] rd-quote-text-white rd-quote-px-3 rd-quote-rounded-md ${isDisabled ? 'rd-quote-opacity-50 rd-quote-cursor-not-allowed' : ''}`}
                  onClick={() => {
                    // Mark button as clicked
                    setIsButtonClicked(true);

                    // CASE 1: If 'Enable Location on Quote Request' switch is ON
                    if (userSettings?.isQuoteLocationsEnabled) {
                      // Validate form
                      if (!isFormValid(formdata)) {
                        setProgressState(4);
                        setCurrentState('FORM');
                        reactHookFormData.trigger();
                        return;
                      } else {
                        setButtonClicked("quote");
                        setProgressState(5);
                        setCurrentState('BOOKING');
                      }
                    }
                    
                    // CASE 2: If 'Enable Location on Quote Request' switch is OFF
                    else if (!loading && currentState === "FORM") {
                      submitForm("quote");
                    }
                  }}
                >
                  Get Quote
                </button>
              )}
            </div>
          )}
          {isMobView &&
            ((bookingList.length === 1 && progressState === 5) || (bookingList.length > 1 && progressState === 6)) &&
            userSettings?.isQuoteEnabled &&
            buttonClicked === "quote" &&
            !loading &&
            currentState !== "COMPLETION" && (
              <Button
                submit={() => submitForm("quote")}
                text={"Get Quote"}
                quoteButtonWidth={true}
                disabled={!defaultStore}
              />
            )}
          {isMobView &&
            ((bookingList.length === 1 && progressState === 5) || (bookingList.length > 1 && progressState === 6)) &&
            userSettings?.isAppointmentEnabled &&
            buttonClicked === "appointment" &&
            !loading &&
            currentState !== "COMPLETION" && (
              <Button
                submit={() => submitForm("appointments")}
                text={"Confirm Appointment"}
                appointmentButtonWidth={true}
                disabled={!isAppointmentValid(appointmentDetail)}
              />
            )}
        </AppContext.Provider>

        {/* Top Heading only for Web view */}
        {!isMobView && (
          <div
            className={`${
              loading || buttonLoader ? "rd-quote-w-full" : "rd-quote-w-[250%]"
            } ${
              PAGES[progressState] !== "Category" ? "quote-card-width" : ""
            } rd-quote-flex rd-quote-flex-col rd-quote-justify-center rd-quote-items-center`}
          >
            {/* <div className="rd-quote-w-4/5 rd-quote-text-center rd-quote-font-medium rd-quote-pt-5 sm:rd-quote-text-[16px] md:rd-quote-text-[18px] lg:rd-quote-text-[28px] lg:rd-quote-pt-3">
            Get Instant Price Quote
          </div> */}
            {(!loading || progressState !== 6) && (<div
              className={`rd-quote-text-[14px] lg:rd-quote-text-[22px] ${
                PAGES[progressState] === "Services" ||
                PAGES[progressState] === "Contact Details"
                  ? "quote-padding-left"
                  : ""
              }`}
            >
              {PAGES[progressState] === "Category"
                ? "Select Category"
                : PAGES[progressState] === "Brand"
                ? "Select Brand"
                : PAGES[progressState] === "Model"
                ? "Select Model"
                : PAGES[progressState] === "Issues"
                ? "Select the issues you are facing with your device"
                : PAGES[progressState] === "Enter Contact Details"
                ? "Please provide your Contact Information"
                : currentState === "COMPLETION"
                ? ""
                : (PAGES[progressState] === "Select Store" && bookingList.length === 1)
                ? "Confirm your Request"
                : PAGES[progressState]}
            </div>)}
          </div>
        )}

        {/* Next Button */}
        {progressStateCategory > 0 && progressState === 0 && (
          <span className="rd-quote-w-[10%]" onClick={() => nextState()}>
            <span className="rd-quote-cursor-pointer rd-quote-text-white rd-quote-bg-[var(--button-bg-color)] rd-quote-px-2 rd-quote-py-1 rd-quote-rounded-md"
                style={{'--button-bg-color': userSettings?.colourHex?.buttonAndBorderColor || '#ebebeb'}}>
                  Next
            </span>
          </span>
        )}
      </div>
      <div
        ref={productSectionRef}
        style={isMobView && (progressState !== 0 || progressStateCategory !== 0) ? {
          paddingTop: '60px'
        } : {}}
        className={`quote-main-bg
        ${height < 700
            ? "lg:rd-quote-overflow-y-scroll lg:rd-quote-h-[73vh]"
            : "" }`}
      >
        <div className="quote-colum">
          {currentState !== DISPLAYING_PAGES.COMPLETION && (
            <>
              <div className={`${((progressState === 6 && loading) || ((progressState === 5 && bookingList.length === 1) && loading)) ? '!rd-quote-justify-end' : ''} quote-row-justify rd-quote-mb-2`}>
                {/* Left Side Heading */}
                {(!loading || (progressState !== 6 && !(progressState === 5 && bookingList.length === 1))) && (
                  <p className="quote-text2">
                    {progressState === 5 && bookingList.length === 1 ? "Confirm your Request" : PAGES[progressState]}
                  </p>
                )}
                {/* Right Side Progress Status */}
                {!loading && (
                  <p className="quote-text1">
                    {progressState + 1} of <span>{bookingList.length === 1 ? 6 : 7}</span>
                  </p>
                )}
                {/* Processing Status on Finalizing Request */}
                {loading && (progressState === 6 || (progressState === 5 && bookingList.length === 1)) && (
                  <p className="quote-text1">Processing..</p>
                )}
              </div>
              <ProgressBar
                className="rd-quote-bg-gray-200 xs:rd-quote-mb-3 lg:rd-quote-mb-0"
                now={now}
                style={{ 
                  '--bs-progress-bar-bg': userSettings?.colourHex?.progressBarColor || '#ebebeb'
                }}
              />
            </>
          )}
          {/* If there is no any service available from Backend */}
          {products?.length === 0 && !loading && (
            <div className="rd-quote-my-4">
              <p className="quote-text1 rd-quote-text-center">
                No available services found.{" "}
              </p>
            </div>
          )}
          {/* Center Circular Loader */}
          {loading && (
            <div className="rd-quote-flex rd-quote-h-screen rd-quote-items-center rd-quote-justify-center rd-quote-mx-auto">
              <ClipLoader color={"#000"} loading={loading} size={70} />
            </div>
          )}
            <div
              className={`rd-quote-justify-center 
              ${(progressState === 6 || (progressState === 5 && bookingList.length === 1)) ? "lg:rd-quote-gap-x-4 " : ""} 
              ${
                currentState === "COMPLETION"
                  ? "rd-quote-flex rd-quote-flex-col xs:rd-quote-flex-col md:rd-quote-items-center md:quote-row"
                  : "rd-quote-flex"
              }`}
            >
            <AppContext.Provider
              value={{
                productCartDetail,
                setProductCartDetail,
                productCartData,
                setProductCartData,
                products,
                setProducts,
                setCurrentState,
                currentState,
                setProgressState,
                formdata,
                setFormData,
                notificationWay,
                setNotificationWay,
                allProducts,
                setAllProducts,
                loading,
                setLoading,
                prevState,
                setPrevState,
                progressState,
                currentModelsServices,
                setCurrentModelsServices,
                appointmentDetail,
                setAppointmentDetail,
                fetchTimeLoading,
                setFetchTimeLoading,
                isMissedItem,
                setIsMissedItem,
                selectedStoreDetails,
                setSelectedStoreDetails,
                allServices,
                setAllServices,
                userSettings,
                setUserSettings,
                allServicesForSubId,
                setAllServicesForSubId,
                encryptionKey,
                setEncryptionKey,
                errors,
                setErrors,
                reactHookFormData,
                setReactHookFormData,
                buttonClicked,
                setButtonClicked,
                widthProductSection,
                setWidthProductSection,
                defaultStore,
                setDefaultStore,
                countryDetails,
                setCountryDetails,
                toggle,
                setToggle,
                selectedBookingPage,
                setSelectedBookingPage,
                buttonLoader,
                setButtonLoader,
                isWebView,
                othersWorkflow,
                setOthersWorkflow,
                isButtonClicked,
                setIsButtonClicked,
                isBillable,
                setIsBillable,
                bookingList,
                setBookingList,
                filteredBookingList,
                setFilteredBookingList,
                prevStateCategory,
                setPrevStateCategory,
                progressStateCategory,
                setProgressStateCategory,
                selectedCategory,
                setSelectedCategory,
              }}
            >
              {/* Show dynamic pages */}
              {currentState === DISPLAYING_PAGES.PRODUCT && encryptionKey && (
                <ProductList />
              )}
              {currentState === DISPLAYING_PAGES.FORM && <ContactDeatils />}
              {currentState === DISPLAYING_PAGES.BOOKING && !loading && <Bookinglist />}
              {currentState === DISPLAYING_PAGES.COMPLETION && !loading && <Completion />}
              {((productCartDetail &&
                products?.length &&
                progressState >= 3 &&
                (progressState <= 6 || (progressState <= 5 && bookingList.length === 1))) ||
                (productCartData &&
                  products?.length &&
                  progressState >= 3 &&
                  (progressState <= 6 || (progressState <= 5 && bookingList.length === 1)))) &&
                currentState !== "COMPLETION" && !loading && <Cart />}
            </AppContext.Provider>
          </div>  
        </div>
      </div>
    </>
  );
};

export default AppManager;
